module.exports = __webpack_public_path__ + "images/entity-exclude-6decc13f.svg";